var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-container" }, [
    _c("div", { staticClass: "c-bill-estimate" }, [
      _c("div", { staticClass: "grid-x" }, [
        _c("div", { staticClass: "cell medium-4" }, [
          _c("img", {
            staticClass: "c-bill-estimate__image c-bill-estimate__image--01",
            attrs: { src: _vm.billEstimateImage1, alt: "" }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "c-bill-estimate__image c-bill-estimate__image--02",
            attrs: { src: _vm.billEstimateImage2, alt: "" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cell medium-7" }, [
          _c("h1", { staticClass: "c-bill-estimate__title" }, [
            _vm._v(_vm._s(_vm.billEstimateTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-bill-estimate__step" }, [
            _c("h2", { staticClass: "c-bill-estimate__step-title" }, [
              _vm._v("Step 1")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "c-bill-estimate__step-description",
              domProps: { innerHTML: _vm._s(_vm.billEstimateStep1) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-bill-estimate__step" }, [
            _c("h2", { staticClass: "c-bill-estimate__step-title" }, [
              _vm._v("Step 2")
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "c-bill-estimate__step-description",
              domProps: { innerHTML: _vm._s(_vm.billEstimateStep2) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-bill-estimate__calculator" }, [
            _c("div", { staticClass: "c-bill-estimate__calculator-item" }, [
              _c(
                "label",
                {
                  staticClass: "c-bill-estimate__label",
                  attrs: { for: "water-use" }
                },
                [
                  _vm._v(
                    "Please enter your estimated annual water use in cubic meters (m³)"
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "c-bill-estimate__input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.waterUse,
                      expression: "waterUse"
                    }
                  ],
                  staticClass: "c-bill-estimate__input-field",
                  attrs: {
                    type: "number",
                    step: "0.01",
                    name: "water-use",
                    id: "water-use",
                    min: "0",
                    max: "400",
                    "aria-describedby": "form-unit-01"
                  },
                  domProps: { value: _vm.waterUse },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.waterUse = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "c-bill-estimate__input-unit",
                    attrs: { id: "form-unit-01" }
                  },
                  [_vm._v("m³")]
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.waterUseError,
                      expression: "waterUseError"
                    }
                  ],
                  staticClass: "c-bill-estimate__error"
                },
                [_vm._v(_vm._s(_vm.waterUseError))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-bill-estimate__calculator-item" }, [
              _c(
                "label",
                {
                  staticClass: "c-bill-estimate__label",
                  attrs: { for: "current-bill" }
                },
                [_vm._v("Please enter your annual bill")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "c-bill-estimate__input" }, [
                _c(
                  "span",
                  {
                    staticClass: "c-bill-estimate__input-unit",
                    attrs: { id: "form-unit-02" }
                  },
                  [_vm._v("£")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentBill,
                      expression: "currentBill"
                    }
                  ],
                  staticClass: "c-bill-estimate__input-field",
                  attrs: {
                    type: "number",
                    step: "0.01",
                    name: "current-bill",
                    id: "current-bill",
                    min: "0",
                    "aria-describedby": "form-unit-02"
                  },
                  domProps: { value: _vm.currentBill },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.currentBill = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentBillError,
                    expression: "currentBillError"
                  }
                ],
                staticClass: "c-bill-estimate__error"
              },
              [_vm._v(_vm._s(_vm.currentBillError))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-bill-estimate__calculator-actions" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.calcWaterCharges()
                    }
                  }
                },
                [_vm._v("Calculate charges")]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showResults,
                  expression: "showResults"
                }
              ]
            },
            [
              _c("table", { staticClass: "c-bill-estimate__charges" }, [
                _c(
                  "caption",
                  { staticClass: "c-bill-estimate__charges-title" },
                  [_vm._v("Water charges")]
                ),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [
                      _vm._v(
                        "Water charges (estimated use x £" +
                          _vm._s(_vm.waterCharge) +
                          " per\n              m³)"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.estimatedWaterCharge))]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [_vm._v("Plus annual standing charge")]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.standingWaterCharge))]
                  )
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "c-bill-estimate__charges-total" }, [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [_vm._v("Total")]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.totalWaterCharge))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "c-bill-estimate__charges" }, [
                _c(
                  "caption",
                  { staticClass: "c-bill-estimate__charges-title" },
                  [_vm._v("Sewage charges*")]
                ),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [
                      _vm._v(
                        "Your estimate of water returned to the sewer (95%\n              of water use)"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v(_vm._s(_vm.estimatedReturnedWater) + "m³")]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [
                      _vm._v(
                        "Sewerage charge (estimated use x £" +
                          _vm._s(_vm.sewerageCharge) +
                          " per\n              m³)"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.estimatedSewerageCharge))]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [_vm._v("Plus annual standing charge")]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.standingSewageCharge))]
                  )
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "c-bill-estimate__charges-total" }, [
                  _c(
                    "th",
                    {
                      staticClass: "c-bill-estimate__charges-item",
                      attrs: { scope: "row" }
                    },
                    [_vm._v("Total")]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__charges-item c-bill-estimate__charges-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.totalSewerageCharge))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "c-bill-estimate__results" }, [
                _c("tr", [
                  _c("th", { staticClass: "c-bill-estimate__results-item" }, [
                    _vm._v("Your total estimated metered bill")
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "c-bill-estimate__results-item c-bill-estimate__results-item--data"
                    },
                    [_vm._v("£" + _vm._s(_vm.totalEstimatedMeteredBill))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSavings,
                        expression: "showSavings"
                      }
                    ]
                  },
                  [
                    _c(
                      "th",
                      { staticClass: "c-bill-estimate__results-savings" },
                      [_vm._v("Switching to a meter could save you")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass:
                          "c-bill-estimate__results-savings c-bill-estimate__results-savings--data"
                      },
                      [_vm._v("£" + _vm._s(_vm.totalSavings))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Please note that this estimate is based on our 2026-27 charges."
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-bill-estimate__footnote" }, [
      _c("p", [
        _vm._v(
          "We've included the standing charges. These cover the cost of maintaining and reading the meter, and producing your bill."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Sewerage standing charge also covers the cost of surface water and highway drainage."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "*If you receive sewerage services from another company. Compare the total estimated water charges with your most recent annual water bill to see if you would save money by switching."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1058124", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1058124","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/bill-estimate/MeteredBill.vue
// module id = 674
// module chunks = 0